export default "__VITE_ASSET__DGRX96eP__$_?inline__"